import Reveal from "@/components/site/Reveal";

const OBSERVATIONS = [
  {
    label: "What I look at first",
    lead: "Your first three photos, title, and visible positioning.",
    sub: "Most guests decide how they feel about a property before they ever read the description.",
  },
  {
    label: "Where revenue tends to leak",
    lead: "Usually not in effort. Usually in positioning, trust signals, and guest perception.",
    sub: "The strongest properties feel intentional before a guest ever books.",
  },
  {
    label: "What changes the most",
    lead: "The business starts feeling lighter to run.",
    list: ["Less second-guessing.", "Less noise.", "Clearer decisions.", "Stronger bookings.", "More structure."],
  },
];

export default function ApproachBlock() {
  return (
    <section data-testid="home-approach" className="py-24 lg:py-32 bg-ivory">
      <div className="container-editorial">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <Reveal as="div" className="lg:col-span-5">
            <p className="overline mb-6">The Approach</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] text-navy leading-[1.15]">
              How I think about{" "}
              <em className="font-serif italic text-sage">your business.</em>
            </h2>

            <div className="mt-8 space-y-5 max-w-md">
              <p className="font-serif text-[1.2rem] md:text-[1.3rem] text-navy leading-[1.45]">
                Most properties don't have a revenue problem first.
                <br />
                They have a clarity problem.
              </p>
              <p className="font-sans text-charcoal/70 text-[15px] leading-[1.8]">
                I look at the small things that quietly shape trust, perception, pricing power, and booking behavior.
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-7 space-y-12 lg:space-y-14">
            {OBSERVATIONS.map((o, i) => (
              <Reveal key={i} delay={i * 120}>
                <div className="grid grid-cols-12 gap-6 items-baseline">
                  <div className="col-span-12 md:col-span-4">
                    <span className="font-ui uppercase tracking-[0.16em] text-[13px] font-semibold text-navy/80">
                      0{i + 1} · {o.label}
                    </span>
                  </div>
                  <div className="col-span-12 md:col-span-8">
                    <p className="font-serif text-navy text-[1.25rem] md:text-[1.4rem] leading-[1.45]">
                      {o.lead}
                    </p>
                    {o.sub && (
                      <p className="font-sans text-charcoal/65 text-[15px] leading-[1.75] mt-4">
                        {o.sub}
                      </p>
                    )}
                    {o.list && (
                      <ul className="mt-5 space-y-2">
                        {o.list.map((item, j) => (
                          <li key={j} className="font-sans text-charcoal/75 text-[15px] leading-[1.7]">
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                {i < OBSERVATIONS.length - 1 && (
                  <span className="block w-full h-px bg-warmGray/25 mt-12 lg:mt-14" />
                )}
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
